import script from "./GastronomyPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./GastronomyPage.vue?vue&type=script&setup=true&lang=ts"

import "./GastronomyPage.vue?vue&type=style&index=0&id=936f62c6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-936f62c6"]])

export default __exports__